import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { FetchBespokeEnquiries, UpdateBespokeEnquiryStatus } from "./BespokeEnquirySlice";

const BespokeEnquiryList = () => {
  console.log('BespokeEnquiryList component mounted');
  const dispatch = useDispatch();
  const list = useSelector((state) => state.bespokeEnquiry.list);
  const loading = useSelector((state) => state.bespokeEnquiry.loading);
  const error = useSelector((state) => state.bespokeEnquiry.error);
  const [activeTab, setActiveTab] = useState(0); // 0 = not resolved, 1 = resolved
  const [viewEnquiry, setViewEnquiry] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [resolvingId, setResolvingId] = useState(null);
  const [search, setSearch] = useState("");

  const getEnquiries = useCallback(() => {
    dispatch(FetchBespokeEnquiries({ status: activeTab, search }));
  }, [dispatch, activeTab, search]);

  useEffect(() => {
    getEnquiries();
  }, [getEnquiries]);

  const handleView = (enquiry) => {
    setViewEnquiry(enquiry);
    setShowViewModal(true);
  };

  const handleResolve = async (id) => {
    setResolvingId(id);
    const response = await dispatch(UpdateBespokeEnquiryStatus({
      id: id,
      status: 1 // 1 = resolved
    }));
    
    if (response?.payload?.code === 1) {
      getEnquiries();
    }
    setResolvingId(null);
  };

  const getStatusBadge = (status) => {
    const statusNum = parseInt(status);
    return statusNum === 1
      ? <span style={{
          backgroundColor: '#28a745',
          color: '#fff',
          padding: '5px 10px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: '500'
        }}>Resolved</span>
      : <span style={{
          backgroundColor: '#ffc107',
          color: '#000',
          padding: '5px 10px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: '500'
        }}>Pending</span>;
  };

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/users.png" alt="" />{" "}
                Bespoke Enquiries {list.length}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search Enquiries"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </form>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-sm-12">
            <div className="tab-content">
              <ul className="nav nav-tabs mb-3">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
                    onClick={() => setActiveTab(0)}
                  >
                    Pending
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                    onClick={() => setActiveTab(1)}
                  >
                    Resolved
                  </button>
                </li>
              </ul>

              <div className="table-responsive text-center">
                {error ? (
                  <div className="text-center py-5">
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                    <button className="btn btn-primary" onClick={getEnquiries}>
                      Retry
                    </button>
                  </div>
                ) : loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : list.length === 0 ? (
                  <div className="text-center py-5">
                    <p className="text-muted">No enquiries found</p>
                  </div>
                ) : (
                  <table className="table storetable">
                    <thead className="text-center">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Company Name</th>
                        <th scope="col">Contact Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Students</th>
                        <th scope="col">Teachers</th>
                        <th scope="col">Locations</th>
                        <th scope="col">Status</th>
                        <th scope="col">Date</th>
                        <th scope="col">Actions</th>
                      </tr>
                      <tr className="border-0 bg-none invisible">
                        <td className="border-0 bg-none"></td>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((enquiry) => (
                        <tr key={enquiry.id}>
                          <td>{enquiry.id || "NA"}</td>
                          <td>{enquiry.company_name || "NA"}</td>
                          <td>{enquiry.contact_name || "NA"}</td>
                          <td>{enquiry.email_address || "NA"}</td>
                          <td>{enquiry.phone_number || "NA"}</td>
                          <td>{enquiry.number_of_active_students || '-'}</td>
                          <td>{enquiry.number_of_teachers || '-'}</td>
                          <td>{enquiry.number_of_locations || '-'}</td>
                          <td>{getStatusBadge(enquiry.status)}</td>
                          <td>{moment(enquiry.createdAt).format('DD-MM-YYYY')}</td>
                          <td>
                            <div className="d-flex justify-content-center action">
                              <button
                                className="btn"
                                onClick={() => handleView(enquiry)}
                                title="View Details"
                              >
                                <img src="assets/images/view.png" alt="" />
                              </button>
                              {enquiry.status === 0 && (
                                <button
                                  className="btn"
                                  onClick={() => handleResolve(enquiry.id)}
                                  disabled={resolvingId === enquiry.id}
                                  title="Mark as Resolved"
                                >
                                  {resolvingId === enquiry.id ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                  ) : (
                                    <img src="assets/images/time-colored.png" alt="" />
                                  )}
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* View Modal */}
      {showViewModal && viewEnquiry && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Bespoke Enquiry Details</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowViewModal(false)}
                  style={{ fontSize: '42px', color: '#000', opacity: '0.7', border: 'none' }}
                  onMouseEnter={(e) => e.target.style.opacity = '1'}
                  onMouseLeave={(e) => e.target.style.opacity = '0.5'}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <strong>Company Name:</strong>
                    <p>{viewEnquiry.company_name}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Contact Name:</strong>
                    <p>{viewEnquiry.contact_name}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Email Address:</strong>
                    <p>{viewEnquiry.email_address}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Phone Number:</strong>
                    <p>{viewEnquiry.phone_number}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Active Students:</strong>
                    <p>{viewEnquiry.number_of_active_students || 'Not specified'}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Teachers/Instructors:</strong>
                    <p>{viewEnquiry.number_of_teachers || 'Not specified'}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Locations:</strong>
                    <p>{viewEnquiry.number_of_locations || 'Not specified'}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Expected Go-Live Date:</strong>
                    <p>
                      {viewEnquiry.expected_go_live_date
                        ? moment(viewEnquiry.expected_go_live_date).format('DD-MM-YYYY')
                        : 'Not specified'}
                    </p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Status:</strong>
                    <p>{getStatusBadge(viewEnquiry.status)}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Submitted On:</strong>
                    <p>{moment(viewEnquiry.createdAt).format('DD-MM-YYYY HH:mm:ss')}</p>
                  </div>
                  <div className="col-md-12 mb-3">
                    <strong>Brief Description:</strong>
                    <p>{viewEnquiry.brief_description || 'No description provided'}</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {viewEnquiry.status === 0 && (
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      handleResolve(viewEnquiry.id);
                      setShowViewModal(false);
                    }}
                    disabled={resolvingId === viewEnquiry.id}
                  >
                    {resolvingId === viewEnquiry.id ? (
                      <>
                        <i className="fa fa-spinner fa-spin mr-2"></i>
                        Resolving...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-check mr-2"></i>
                        Mark as Resolved
                      </>
                    )}
                  </button>
                )}
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowViewModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </article>
  );
};

export default BespokeEnquiryList;
